import { useState } from 'react';
import { CancelIconLight, ChevronRightIconLight } from '@/ui';
import { ISiteSectionEntry } from '../../../../contentful/types/ISiteSection';
import { IMenuItemEntry } from '../../../../contentful/types/IMenuItem';
import MobileNavigationSubmenuItems from './MobileNavigationSubmenuItems';
import { getActivePageProps } from '../../../../navigation/getActivePageProps';
import { getUrlForPageId } from '../../../../utils/getUrlForLink';
import { useCommonData } from '../../../../common-data/useCommonData';
import {
	ToggleButton,
	MobileMenu,
	StyledLink,
	MobileHeader,
	MobileHeaderTitle,
	CloseButton,
	StyledAccordion,
	StyledAccordionItem,
	SiteSectionScrollWrap,
	Wrapper,
} from './MobileNavigation.styles';
import { SiteSections } from './SiteSections';
import SearchButton from '../../button/SearchButton';

interface IMobileNavigationProps {
	siteSections: ISiteSectionEntry[];
	currentSiteSection?: ISiteSectionEntry;
	items?: IMenuItemEntry[];
	onSiteSectionIdChange: (id: string) => void;
	siteSectionId?: string;
	isSticky: boolean;
	displayTopSiteSectionNavigation?: boolean;
	siteSection?: ISiteSectionEntry;
}

export default function MobileNavigation({
	siteSections,
	onSiteSectionIdChange,
	siteSectionId,
	items,
	isSticky,
	displayTopSiteSectionNavigation,
}: IMobileNavigationProps) {
	const { pathToPageIdMap } = useCommonData();
	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

	const toggleMobileMenu = () => {
		setIsMobileMenuOpen(!isMobileMenuOpen);
	};

	return (
		<>
			<MobileMenu open={isMobileMenuOpen}>
				{isMobileMenuOpen && (
					<>
						<MobileHeader>
							<MobileHeaderTitle>Menu</MobileHeaderTitle>
							<CloseButton onClick={toggleMobileMenu} autoFocus>
								<CancelIconLight />
							</CloseButton>
						</MobileHeader>

						<SiteSectionScrollWrap>
							{displayTopSiteSectionNavigation && (
								<SiteSections
									siteSections={siteSections}
									siteSectionId={siteSectionId}
									onSiteSectionIdChange={onSiteSectionIdChange}
									collapsed={false}
								/>
							)}
						</SiteSectionScrollWrap>

						<StyledAccordion>
							{items &&
								items?.map((item: IMenuItemEntry) =>
									item.fields.subMenuItems?.length ? (
										<StyledAccordionItem
											key={item.id}
											title={item.fields.title}
											icon={
												!item.fields.subMenuItems && <ChevronRightIconLight />
											}
											reverseIcon
										>
											{item?.fields?.subMenuItems && (
												<MobileNavigationSubmenuItems
													subMenuItems={item.fields.subMenuItems}
												/>
											)}
										</StyledAccordionItem>
									) : (
										item.fields.page && (
											<StyledLink
												{...getActivePageProps(item, siteSectionId)}
												key={item.id}
												href={getUrlForPageId(
													item.fields.page.fields.id,
													pathToPageIdMap,
												)}
												title={item.fields.title}
											>
												<StyledAccordionItem
													title={item.fields.title}
													icon={
														!item.fields.subMenuItems && (
															<ChevronRightIconLight />
														)
													}
													reverseIcon
												/>
											</StyledLink>
										)
									),
								)}
						</StyledAccordion>
					</>
				)}
			</MobileMenu>

			<Wrapper isSticky={isSticky} aria-hidden={isMobileMenuOpen}>
				<SearchButton />
				<ToggleButton onClick={toggleMobileMenu}>Menu</ToggleButton>
			</Wrapper>
		</>
	);
}
